import { aboutContent, siteInfo } from '@/mocks/data';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于樱桃视频',
            description: siteInfo.description,
            url: 'https://www.yingtao-video.com/about',
            isPartOf: {
              '@type': 'WebSite',
              name: '樱桃视频',
              url: 'https://www.yingtao-video.com/',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.yingtao-video.com/' },
              { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://www.yingtao-video.com/about' },
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              { '@type': 'Question', name: '樱桃视频是免费的吗？', acceptedAnswer: { '@type': 'Answer', text: '是的，樱桃视频所有内容完全免费，无需会员，无需付费即可享受高清观影体验。' } },
              { '@type': 'Question', name: '樱桃视频支持哪些设备？', acceptedAnswer: { '@type': 'Answer', text: '樱桃视频支持PC端网页、手机浏览器、平板等多种设备，无需下载APP即可在线观看。' } },
              { '@type': 'Question', name: '樱桃视频资源更新频率如何？', acceptedAnswer: { '@type': 'Answer', text: '樱桃视频每日更新1000+高清资源，热门影视第一时间上线，确保用户不会错过精彩内容。' } },
              { '@type': 'Question', name: '樱桃视频画质怎么样？', acceptedAnswer: { '@type': 'Answer', text: '樱桃视频支持1080P和4K超高清画质，采用先进的视频编码技术，在保证画质的同时确保流畅播放。' } },
            ],
          }),
        }}
      />

      {/* Breadcrumb */}
      <div className="bg-background-100 border-b border-background-200/60">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-3">
          <nav className="flex items-center gap-2 text-sm" aria-label="面包屑导航">
            <Link to="/" className="text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">首页</Link>
            <i className="ri-arrow-right-s-line text-foreground-600 text-xs"></i>
            <span className="text-foreground-200 font-medium">关于我们</span>
          </nav>
        </div>
      </div>

      {/* Hero */}
      <section className="w-full bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16 text-center">
          <h1 className="text-2xl md:text-4xl font-bold text-foreground-50 font-heading">
            关于 <span className="text-primary-400">樱桃视频</span>
          </h1>
          <p className="mt-4 text-sm md:text-base text-foreground-400 max-w-2xl mx-auto leading-relaxed">
            {siteInfo.description}
          </p>
        </div>
      </section>

      {/* Intro */}
      <section className="w-full bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
          <div className="flex flex-col lg:flex-row gap-10 items-center">
            <div className="flex-1">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading mb-4">品牌故事</h2>
              <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-4">{aboutContent.intro}</p>
              <p className="text-sm md:text-base text-foreground-400 leading-relaxed">{aboutContent.mission}</p>

              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8">
                {[
                  { value: siteInfo.users, label: '累计用户' },
                  { value: siteInfo.videos, label: '影视资源' },
                  { value: siteInfo.dailyActive, label: '日活用户' },
                  { value: '99.9%', label: '播放流畅率' },
                ].map((stat) => (
                  <div key={stat.label} className="text-center p-4 rounded-xl bg-background-50 border border-background-200/40">
                    <div className="text-xl md:text-2xl font-bold text-primary-400 font-heading">{stat.value}</div>
                    <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className="lg:w-[420px] flex-shrink-0">
              <div className="rounded-xl overflow-hidden bg-background-200 aspect-video">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20movie%20streaming%20office%20with%20large%20screens%20displaying%20film%20content%2C%20creative%20workspace%20with%20warm%20ambient%20lighting%2C%20professional%20tech%20environment%2C%20clean%20aesthetic&width=800&height=450&seq=about-hero-video&orientation=landscape"
                  alt="樱桃视频品牌形象"
                  title="樱桃视频 - 品牌介绍"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="w-full bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading text-center mb-2">核心优势</h2>
          <p className="text-sm text-foreground-500 text-center mb-10">我们致力于为用户提供最优质的观影体验</p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {aboutContent.features.map((feature) => (
              <div key={feature.title} className="p-6 rounded-xl bg-background-100 border border-background-200/40 hover:border-primary-500/20 transition-all duration-300">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-500/10 mb-4">
                  <i className={`${feature.icon} text-primary-400 text-2xl`}></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-100 mb-2">{feature.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="w-full bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading text-center mb-2">用户口碑</h2>
          <p className="text-sm text-foreground-500 text-center mb-10">听听用户们怎么说</p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {aboutContent.testimonials.map((t) => (
              <div key={t.name} className="p-5 rounded-xl bg-background-50 border border-background-200/40">
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: t.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent-400 text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-400 leading-relaxed mb-4">&ldquo;{t.text}&rdquo;</p>
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-full bg-primary-500/20 flex items-center justify-center">
                    <span className="text-primary-400 text-sm font-bold">{t.name[0]}</span>
                  </div>
                  <span className="text-sm text-foreground-300 font-medium">{t.name}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact */}
      <section className="w-full bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading text-center mb-2">联系我们</h2>
          <p className="text-sm text-foreground-500 text-center mb-10">如有任何问题或建议，欢迎通过以下方式联系我们</p>

          <div className="max-w-2xl mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="p-5 rounded-xl bg-background-100 border border-background-200/40 flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 flex-shrink-0">
                  <i className="ri-mail-line text-primary-400 text-lg"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-200">电子邮箱</h4>
                  <p className="text-sm text-foreground-400 mt-1">{aboutContent.contact.email}</p>
                </div>
              </div>
              <div className="p-5 rounded-xl bg-background-100 border border-background-200/40 flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 flex-shrink-0">
                  <i className="ri-wechat-line text-primary-400 text-lg"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-200">微信公众号</h4>
                  <p className="text-sm text-foreground-400 mt-1">{aboutContent.contact.wechat}</p>
                </div>
              </div>
              <div className="p-5 rounded-xl bg-background-100 border border-background-200/40 flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 flex-shrink-0">
                  <i className="ri-weibo-line text-primary-400 text-lg"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-200">新浪微博</h4>
                  <p className="text-sm text-foreground-400 mt-1">{aboutContent.contact.weibo}</p>
                </div>
              </div>
              <div className="p-5 rounded-xl bg-background-100 border border-background-200/40 flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 flex-shrink-0">
                  <i className="ri-map-pin-line text-primary-400 text-lg"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-200">公司地址</h4>
                  <p className="text-sm text-foreground-400 mt-1">{aboutContent.contact.address}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="w-full bg-background-100">
        <div className="max-w-3xl mx-auto px-4 md:px-6 py-14 text-center">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">立即开始免费观影</h2>
          <p className="mt-3 text-sm text-foreground-400">加入{siteInfo.users}用户的观影选择，享受流畅高清的免费影视体验</p>
          <Link
            to="/category/dianying"
            className="mt-6 inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-foreground-50 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            开始观影 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </section>
    </>
  );
}